import { Component } from "@angular/core";
import { Http, Response, Headers, RequestOptions } from "@angular/http";
import { Observable } from "rxjs/Observable";
import { UserData, LoginModel, FileSearch, SearchDashboardDataContainer } from "../../model/index"
import { OtpModel } from "../../Model/ServicePayment/OtpModel";
declare let CryptoJS: any;
@Component({
    providers: [Http]
})
export class LoginService {
    constructor(private _http: Http) {
    }
    private _Loginurl: string = "api/login/validate";
    private _SentOtpurl: string = "api/login/SentOtpToRegisteredMobileNumber";
    private _LoginSearchDetailsurl: string = "api/login/LoginSearchDetails";
    private _CurrencyDetailsurl: string = "api/login/CurrencyDetails";   
    private  _LogoDetailsurl: string  = "api/login/GetLogoImage";
    private _getLoggedInUserImageurl: string = "api/login/LoggedInUserImage"; 
    private _getAppointmentPatientSearchurl: string = "api/login/AppointmentPatientSearch"; 
    public validCredentials(loginInfo: LoginModel): Observable<UserData> {
        var key = CryptoJS.enc.Utf8.parse(loginInfo.SecureValue);
        var iv = CryptoJS.enc.Utf8.parse(loginInfo.SecureValue);
        var encryptedUserName = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(loginInfo.username), key,
            {
                keySize: 128 / 8,
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            });
        var encryptedPassword = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(loginInfo.password), key,
            {
                keySize: 128 / 8,
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            });
        var userid: string = encryptedUserName.toString();
        var pwd: string = encryptedPassword.toString();
        var pid: string = "";
        
        var userData: UserData = new UserData(userid,"", pwd,false);
        var authentication: string = "testAuth";

        let body: string = JSON.stringify(userData);
        let headers: Headers = new Headers({ "Content-Type": "application/json" });
        var antiForgeryToken = $("input[name=__RequestVerificationToken]").val();
        headers.append("__RequestVerificationToken", antiForgeryToken);
        headers.append("MentisSoftAuthorization", "Basic " + btoa(userid + ":" + authentication));
        let options: RequestOptions = new RequestOptions({ headers: headers });

        let data$: Observable<UserData> = this._http.post(this._Loginurl, body, options)
            .map(res => <UserData>res.json())
            .catch(this.handleError);
        return data$;
    }

    public GetCurrencyDetails(loginInfo: LoginModel) {
        var userid: string = loginInfo.username;
        var pwd: string = loginInfo.password;
        var pid: string = "";
        var userData: UserData = new UserData(userid, "", pwd, false);
        var authentication: string = "testAuth";
      
        let headers: Headers = new Headers({ "Content-Type": "application/json" });
        headers.append("MentisSoftAuthorization", "Basic " + btoa(userid + ":" + authentication));
        var antiForgeryToken = $("input[name=__RequestVerificationToken]").val();
        headers.append("__RequestVerificationToken", antiForgeryToken);
        let options: RequestOptions = new RequestOptions({ headers: headers });

        let data$ = this._http.post(this._CurrencyDetailsurl, "", options)
            .map(res => res.json())
            .catch(this.handleError);
        return data$;
    }

    public GetLogo(loginInfo: LoginModel): Observable<UserData> {
        var userid: string = loginInfo.username;
        var pwd: string = loginInfo.password;
        var pid: string = "";
        var userData: UserData = new UserData(userid, "", pwd, false);
        var authentication: string = "testAuth";

        let body: string = JSON.stringify(userData);
        let headers: Headers = new Headers({ "Content-Type": "application/json" });
        headers.append("MentisSoftAuthorization", "Basic " + btoa(userid + ":" + authentication));
        var antiForgeryToken = $("input[name=__RequestVerificationToken]").val();
        headers.append("__RequestVerificationToken", antiForgeryToken);
        let options: RequestOptions = new RequestOptions({ headers: headers });

        let data$: Observable<UserData> = this._http.post(this._LogoDetailsurl, body, options)
            .map(res => <UserData>res.json())
            .catch(this.handleError);
        return data$;
    }
    public GetLoggedInUserImage() {
        let body = "";
        let headers: Headers = new Headers({ "Content-Type": "application/json" });
        var antiForgeryToken = $("input[name=__RequestVerificationToken]").val();
        headers.append("__RequestVerificationToken", antiForgeryToken);
        headers.append("MentisSoftAuthorization", "Basic " + btoa("" + ":" + ""));
        let options: RequestOptions = new RequestOptions({ headers: headers });

        let data$ = this._http.post(this._getLoggedInUserImageurl, body, options)
            .map(res => res.json())
            .catch(this.handleError);
        return data$;
    } 

    public getAppointmentPatientSearch(fileSearch: FileSearch): Observable<SearchDashboardDataContainer> {
        let body: string = JSON.stringify(fileSearch);
        let headers: Headers = new Headers({ "Content-Type": "application/json" });
        var antiForgeryToken = $("input[name=__RequestVerificationToken]").val();
        headers.append("__RequestVerificationToken", antiForgeryToken);
        headers.append("MentisSoftAuthorization", "Basic " + btoa("" + ":" + ""));
        let options: RequestOptions = new RequestOptions({ headers: headers });

        let data$: Observable<SearchDashboardDataContainer> = this._http.post(this._getAppointmentPatientSearchurl, body, options)
            .map(res => <SearchDashboardDataContainer>res.json())
            .catch(this.handleError);
        return data$;
    }


    public SentOtp(details: OtpModel, userInfo: UserData) {
        let body: string = JSON.stringify(details);
        let headers: Headers = new Headers({ "Content-Type": "application/json" });
        var antiForgeryToken = $("input[name=__RequestVerificationToken]").val();
        headers.append("__RequestVerificationToken", antiForgeryToken);
        headers.append("MentisSoftAuthorization", "Basic " + btoa(userInfo.User + ":" + userInfo.Authentication));
        let options: RequestOptions = new RequestOptions({ headers: headers });

        let data$ = this._http.post(this._SentOtpurl, body, options)
            .map(res => res.json())
            .catch(this.handleError);
        return data$;
    }


    public GetLoginSearchDetails(fileSearch: FileSearch): Observable<SearchDashboardDataContainer> {
        let body: string = JSON.stringify(fileSearch);
        let headers: Headers = new Headers({ "Content-Type": "application/json" });
        var antiForgeryToken = $("input[name=__RequestVerificationToken]").val();
        headers.append("__RequestVerificationToken", antiForgeryToken);
        headers.append("MentisSoftAuthorization", "Basic " + btoa("" + ":" + ""));
        let options: RequestOptions = new RequestOptions({ headers: headers });

        let data$: Observable<SearchDashboardDataContainer> = this._http.post(this._LoginSearchDetailsurl, body, options)
            .map(res => <SearchDashboardDataContainer>res.json())
            .catch(this.handleError);
        return data$;
    }

    private handleError(error: Response | any) {
        let errMsg: string;
        if (error instanceof Response) {
            const body = error.json() || "";
            const err = body.error || JSON.stringify(body);
            errMsg = `${error.status} - ${error.statusText || ""} ${err}`;
        } else {
            errMsg = error.message ? error.message : error.toString();
        }
        return Observable.throw(errMsg || " API Server Error");
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/Login/Service/Login.Service.ts